import React from "react";
import Hero from "../../components/Hero/Hero";
import Footer from "../../components/Footer/Footer";
import Navbar from "../../components/layout/Navbar";
import About from "../../components/About/About";

export default function Home() {
  return (
    <>
      <Navbar />
      <Hero />
      <main>
        {/* Use negative margin on the first section to visually connect with hero */}
        <div id="start" style={{ marginTop: "-40px", paddingTop: "80px" }}>
          <About />
        </div>
      </main>
      <Footer />
    </>
  );
}
